import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function ChangerMotDePasse() {
  const [form, setForm] = useState({
    ancien_password: '',
    password: '',
    password_confirmation: '',
  });
  const [loading, setLoading] = useState(false);
  const [erreur, setErreur] = useState('');
  const [succes, setSucces] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErreur('');
    setSucces('');

    if (form.password !== form.password_confirmation) {
      setErreur('Les mots de passe ne correspondent pas.');
      setLoading(false);
      return;
    }

    try {
      const token = localStorage.getItem('token');
      await axios.post('https://efe-systems.com/api/changer-mot-de-passe', form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSucces('Mot de passe changé avec succès !');
      setTimeout(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user?.role === 'admin') {
          navigate('/dashboard/admin');
        } else {
          navigate('/dashboard/client');
        }
      }, 2000);
    } catch (error) {
      setErreur(error.response?.data?.message || 'Une erreur est survenue.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.1)',
    color: 'white',
    borderRadius: '12px',
    padding: '12px 16px',
    width: '100%',
    outline: 'none',
    fontSize: '14px',
    boxSizing: 'border-box',
  };

  return (
    <div style={{ minHeight: '100vh', background: '#050510' }}>
      <Navbar />

      <div
        className="min-h-screen flex items-center justify-center px-6 pt-24 pb-16"
        style={{
          backgroundImage: `
            radial-gradient(ellipse 80% 50% at 20% 40%, rgba(26,26,230,0.12) 0%, transparent 60%),
            radial-gradient(ellipse 60% 40% at 80% 60%, rgba(107,33,232,0.10) 0%, transparent 60%),
            linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)
          `,
          backgroundSize: 'auto, auto, 40px 40px, 40px 40px',
        }}
      >
        <div className="w-full max-w-md">

          {/* Logo */}
          <div className="text-center mb-8">
            <Link to="/" style={{ textDecoration: 'none' }}>
              <span className="text-2xl font-extrabold">
                <span style={{ color: '#F5C500' }}>⚡</span>
                <span style={{ color: '#6B21E8' }}>EFE</span>
                <span style={{ color: 'white' }}> Systems</span>
              </span>
            </Link>
            <p className="text-gray-400 mt-2 text-sm">Sécurisez votre compte</p>
          </div>

          {/* Carte */}
          <div className="rounded-3xl p-8"
            style={{
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.08)',
              backdropFilter: 'blur(20px)',
            }}>

            <h2 className="text-white text-2xl font-extrabold mb-2">
              Changer le mot de passe
            </h2>
            <p className="text-gray-400 text-sm mb-6">
              Pour votre sécurité, veuillez changer votre mot de passe temporaire.
            </p>

            {erreur && (
              <div className="mb-4 px-4 py-3 rounded-xl text-sm"
                style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', color: '#EF4444' }}>
                ❌ {erreur}
              </div>
            )}

            {succes && (
              <div className="mb-4 px-4 py-3 rounded-xl text-sm"
                style={{ background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.3)', color: '#10B981' }}>
                ✅ {succes} Redirection en cours...
              </div>
            )}

            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <div>
                <label className="text-gray-400 text-xs mb-1 block">Mot de passe actuel *</label>
                <input
                  name="ancien_password"
                  type="password"
                  value={form.ancien_password}
                  onChange={handleChange}
                  placeholder="••••••••"
                  required
                  style={inputStyle}
                />
              </div>

              <div>
                <label className="text-gray-400 text-xs mb-1 block">Nouveau mot de passe *</label>
                <input
                  name="password"
                  type="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="Minimum 8 caractères"
                  required
                  style={inputStyle}
                />
              </div>

              <div>
                <label className="text-gray-400 text-xs mb-1 block">Confirmer le nouveau mot de passe *</label>
                <input
                  name="password_confirmation"
                  type="password"
                  value={form.password_confirmation}
                  onChange={handleChange}
                  placeholder="Répétez le mot de passe"
                  required
                  style={inputStyle}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full py-4 rounded-xl font-semibold text-lg transition hover:opacity-90"
                style={{
                  background: '#1A1AE6',
                  color: 'white',
                  border: 'none',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  boxShadow: '0 4px 15px rgba(26,26,230,0.3)',
                }}
              >
                {loading ? 'Changement...' : 'Changer le mot de passe →'}
              </button>
            </form>

            <div className="text-center mt-6">
              <Link to="/"
                style={{ color: 'rgba(255,255,255,0.4)', textDecoration: 'none', fontSize: '14px' }}>
                ← Retour à l'accueil
              </Link>
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ChangerMotDePasse;